import { IModule, ModuleID } from '../types'

const VoidModule: IModule = {
  get id(): ModuleID {
    return ModuleID.VOID
  },
  config(_props) {
    return VoidModule
  },
  // eslint-disable-next-line @typescript-eslint/require-await
  async load() {
    return VoidModule
  },
  get loaded() {
    return true
  }
}

export default VoidModule
